import { all, takeLatest } from 'lib/redux';
import { LOAD_SITEMAP_DATA } from '../../constants/ActionTypes';
import loadSitemapPageSaga from './Sitemap.saga';

/**
 * Defines the watchers related to Sitemap Page.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(LOAD_SITEMAP_DATA, loadSitemapPageSaga),
  ]);
}
